import { QrCodeIcon } from "@heroicons/react/24/outline";
import { useSelector } from "react-redux";
import { selectCurrentUserInfo } from "../../store/feautures/AuthSlice";
import { SuperAdminVisore } from "../../utils/genericList/ListRoleRoutes";
import DialogComponent from "../main/DIalogComponent";
import ManageTwoFactor from "../accounts/ManageTwoFactor";


export default function TwoFaReset({ row }: any) {

    const { role } = useSelector(selectCurrentUserInfo);

    return (
        SuperAdminVisore.includes(role)
            ? ((role === 'Admin' || role === 'AdvancedAdmin') && row?.ruolo !== 'SuperAdmin') || role === 'SuperAdmin' || role === 'Supervisore' 
            ?   <DialogComponent
                    icon={<QrCodeIcon className="w-6 h-6" />}
                    label={'Disattiva utente'}
                    content={
                        <ManageTwoFactor row={row} />
                    }
                />
                : <></>
            : <></>
    )
}